<!-- <template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb49></breadcrumb49>
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="!showspinner">
              <div class="row ml-md-3">
                <div class="col-md-12" id="patient_container">
                  <div class="appointment-tab">
                    <div class="tab-content">
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0" style="border: none;">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th style="background-color: #F8F8F8;" class="text-left">Receipt Number</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Date</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Amount</th>
                                     <th style="background-color: #F8F8F8;" class="text-left">Status</th>

                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, $index) in open_receipt" :key="item.id"
                                    v-show="setOpenReceipts($index)">
                                    <td class="text-left">
                                      <a>{{ item.name }}</a>
                                    </td>
                                    <td class="text-left">
                                      {{
                                        item.date ? formatDate(item.date) : "-"
                                      }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.patient_full_name }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.amount === 0 ? "-" : "₹" + item.amount }}
                                    </td>
                                      <td class="text-left">
                                      {{ item.status }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="open_receipt.length === 0 && !showspinner" class="No_data">
                                No Receipts Found
                              </h5>
                            </div>
                            <div id="pagination" v-if="open_receipt.length > 10">
                              <ul class="pagination justify-content-center">

                                <li class="page-item" :class="receipt_current === 1 ? 'disabled' : ''">
                                  <a href="#" class="page-link" aria-label="Previous"
                                    @click.prevent="updateReceiptCurrent(receipt_current - 1)">
                                    Previous
                                  </a>
                                </li>

                                <li v-for="page_index in receipt_paginate_total" :key="page_index.id" :class="[
                                  'page-item',
                                  receipt_current === page_index ? 'active' : ''
                                ]" v-if="page_index >= receipt_current - 2 && page_index <= receipt_current + 2">
                                  <a href="#" class="page-link" @click.prevent="updateReceiptCurrent(page_index)">
                                    {{ page_index }}
                                  </a>
                                </li>

                                <li class="page-item" :class="receipt_current === receipt_paginate_total ? 'disabled' : ''
                                  ">
                                  <a href="#" class="page-link" aria-label="Next"
                                    @click.prevent="updateReceiptCurrent(receipt_current + 1)">
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");

export default {
  data() {
    return {
      config: config,
      open_receipt: [],
      showspinner: true,

      receipt_current: 1,
      receipt_paginate: 10,
      receipt_paginate_total: 0,

    };
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_receipt_data(),
      $(".progressresult").each(function () {
        const percentageToDegrees = (percentage) => {
          return (percentage / 100) * 360;
        };
        let value = $(this).attr("data-value");
        let left = $(this).find(".progress-left .progress-bar");
        let right = $(this).find(".progress-right .progress-bar");

        if (value > 0) {
          if (value <= 50) {
            right.css(
              "transform",
              "rotate(" + percentageToDegrees(value) + "deg)"
            );
          } else {
            right.css("transform", "rotate(180deg)");
            left.css(
              "transform",
              "rotate(" + percentageToDegrees(value - 50) + "deg)"
            );
          }
        }
      });
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),
  },
  methods: {

    setOpenReceipts(i) {
      if (this.receipt_current == 1) {
        return i < this.receipt_paginate;
      } else {
        return (
          i >= this.receipt_paginate * (this.receipt_current - 1) &&
          i < this.receipt_current * this.receipt_paginate
        );
      }
    },

    updateReceiptCurrent(i) {
      this.receipt_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    get_receipt_data() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data("sahaj.api.get_practitioner_opd_receipts", data).then(
        (res) => {
          console.log(res);
          this.showspinner = false;
          if (res.status_code == 200) {
            this.open_receipt = res.data;
            this.receipt_paginate_total = Math.ceil(
              this.open_receipt.length / this.receipt_paginate
            );
          }
        }
      );
    },
  },
};
</script>
<style scoped>
table {
    border-collapse: collapse;
    width: 100%;
    border-top: 1px solid #dddddd;
  }

  th, td {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #F8F8F8;
  }
  </style> -->


  <template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb49></breadcrumb49>

      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="!showspinner">
              <div class="row ml-md-3">
                <div class="col-md-12" id="patient_container">
                  <div class="appointment-tab">
                    <div class="tab-content">
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0" style="border: none;">
                          <div class="card-body">
                            <!-- "Pay Now" Button at the top-right -->
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h4>Receipts</h4>
                              <button class="btn btn-primary" @click="openPayNowModal()">Pay Now</button>
                            </div>

                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th class="text-left">Receipt Number</th>
                                    <th class="text-left">Date</th>
                                    <th class="text-left">Patient Name</th>
                                    <th class="text-left">Amount</th>
                                    <th class="text-left">Status</th>
                                    <th class="text-left">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in open_receipt" :key="item.id">
                                    <td class="text-left">
                                      <a>{{ item.name }}</a>
                                    </td>
                                    <td class="text-left">{{ formatDate(item.date) }}</td>
                                    <td class="text-left">{{ item.patient_full_name }}</td>
                                    <td class="text-left">
                                      {{ item.amount === 0 ? "-" : "₹" + item.amount }}
                                    </td>
                                    <td class="text-left">{{ item.status }}</td>
                                    <td class="text-left">
                                      {{ item.status }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="open_receipt.length === 0 && !showspinner" class="No_data">
                                No Receipts Found
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /recepit data -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pay Now Modal (Medium Size) -->
      <div v-if="showPayNowModal" class="modal-overlay">
        <div class="modal-content">
          <h3 class="modal-title">Pay Now</h3>
          <form @submit.prevent="makePayment">
            <div class="form-group">
              <label>Order ID</label>
              <input type="text" v-model="selectedReceipt.name" class="form-control" />
            </div>
            <div class="form-group">
              <label>Amount</label>
              <input 
                type="text" 
                v-model="selectedReceipt.amount" 
                class="form-control" 
                @input="validateAmount"
                required
              />
              <small v-if="errors.amount" class="text-danger">{{ errors.amount }}</small>
            </div>
            <div class="form-group">
              <label>Customer Name</label>
              <input type="text" v-model="selectedReceipt.patient_full_name" class="form-control" required />
            </div>
            <div class="form-group">
              <label>Mobile Number</label>
              <input type="text" v-model="selectedReceipt.mobile" class="form-control" required />
              <small v-if="errors.mobile" class="text-danger">{{ errors.mobile }}</small>
            </div>
            <div class="form-group">
              <label>Email ID</label>
              <input type="email" v-model="selectedReceipt.email" class="form-control" required />
              <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
            </div>
            <div class="modal-actions">
              <button type="button" class="btn btn-secondary" @click="showPayNowModal = false">Cancel</button>
              <button type="submit" class="btn btn-primary">Proceed to Pay</button>
            </div>
          </form>
        </div>
      </div>

      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "@/services/CommonApi";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      open_receipt: [],
      showspinner: true,
      showPayNowModal: false,
      selectedReceipt: {},
      errors: {},
    };
  },
  mounted() {
    this.get_receipt_data();
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    },

    get_receipt_data() {
      CommonApi.post_data("sahaj.api.get_practitioner_opd_receipts", { practitioner: this.user_id })
        .then((res) => {
          this.showspinner = false;
          if (res.status_code == 200) {
            this.open_receipt = res.data;
          }
        });
    },

    openPayNowModal(item = {}) {
      this.selectedReceipt = { ...item };
      this.showPayNowModal = true;
    },

    validateAmount() {
  this.selectedReceipt.amount = this.selectedReceipt.amount.replace(/\D/g, "");
  if (this.selectedReceipt.amount === "") {
    this.errors.amount = "Amount is required.";
  } else {
    this.errors.amount = "";
  }
},

async makePayment() {
  try {
    console.log("Initiating Payment...");

    // Ensure amount is converted to a number
    const amount = Number(this.selectedReceipt.amount);

    if (isNaN(amount) || amount <= 0) {
      alert("Invalid amount. Please enter a valid number.");
      return;
    }

    console.log("Sending API request with:", {
      order_id: this.selectedReceipt.name,
      amount: amount,
      customer_name: this.selectedReceipt.patient_full_name,
      mobile: this.selectedReceipt.mobile,
      email: this.selectedReceipt.email
    });

    // Call the Frappe API
    const response = await axios.post(
      "https://develop-physio.kneexpert.in/api/method/sahaj.payment.initiate_icici_payment",
      {
        order_id: this.selectedReceipt.name,
        amount: amount,
        customer_name: this.selectedReceipt.patient_full_name,
        mobile: this.selectedReceipt.mobile,
        email: this.selectedReceipt.email
      }
    );

    console.log("API Response:", response.data);

    // Fix: Ensure response contains correct gateway_url
    if (response.data.message.gateway_url) {
      const gateway_url = response.data.message.gateway_url;
      const payload = response.data.message.payload;

      // Create a form dynamically
      let form = document.createElement("form");
      form.method = "POST";
      form.action = gateway_url;

      // Add payload fields as hidden inputs
      for (let key in payload) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = payload[key];
        form.appendChild(input);
      }

      document.body.appendChild(form);
      form.submit();
    } else {
      alert("Error: Payment gateway URL not received.");
    }
  } catch (error) {
    console.error("Payment initiation failed:", error);
    alert("Payment initiation failed. Please try again.");
  }
}


  },
};
</script>


<style scoped>
/* Table Styling */
table {
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #dddddd;
}

th, td {
  border: 1px solid #dddddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #F8F8F8;
}

/* Modal Styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  max-width: 600px;
}

.modal-title {
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Reciept.vue